import { render, staticRenderFns } from "./AppRoles.vue?vue&type=template&id=b4395db4&"
import script from "./AppRoles.vue?vue&type=script&lang=js&"
export * from "./AppRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports